/* eslint-disable no-unused-vars */
import { selectBalance } from "Features/balance/balance.select";
import { taxSelect } from "Pages/Withdraw/store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectWithdraw, withdrawActions } from "Shared/store/withdraw";

const minimal = 20;

export function amountController() {
	const dispatch = useDispatch();
	const balance = useSelector(selectBalance.data);
	const selectedMethod = useSelector(selectWithdraw.method);
	const selectedWallet = useSelector(selectWithdraw.wallet);

	const [amounCount, setAmounCount] = useState();
	const [isDisabled, setIsDisabled] = useState(false);

	useEffect(() => {
		disabledChecker();
	}, [amounCount, selectedWallet, balance]);

	function disabledChecker() {
		if (!selectedWallet || !balance) {
			setIsDisabled(true);
			return;
		}
		if (!amounCount || amounCount < minimal || amounCount > balance.balance) {
			setIsDisabled(true);
			return;
		}
		if (isDisabled) {
			setIsDisabled(false);
		}
	}

	function onChangeCount(value) {
		if (value) {
			setAmounCount(Number(value));
		}
		setAmounCount(value);
	}

	function onProceed(isReachedLimit) {
		setWithdrawParams();
		openModal(isReachedLimit);
	}

	function setWithdrawParams() {
		const withdrawParams = {
			amount: Number(amounCount),
			currencyCode: "EUR",
			tpcWalletId: balance.id,
			walletType: selectedMethod,
			walletId: selectedWallet.id,
		};
		dispatch(withdrawActions.setWithdrawParams(withdrawParams));
	}

	function openModal(isReachedLimit) {
		if (isReachedLimit) {
			dispatch(withdrawActions.setIsVisibleTaxInfo(true));
		} else {
			dispatch(withdrawActions.setVisibleUpdateAcc(true));
		}
	}

	return {
		amounCount,
		setAmounCount: onChangeCount,
		minimal,
		isDisabled,
		onClick: onProceed,
	};
}
